/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Program_Audio_LabelInputs */



/**
* | output |
* | --- |
* | "Program Audio (Optional)" |
*
* @param {Audio_Description_Export_Program_Audio_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_program_audio_label = /** @type {((inputs?: Audio_Description_Export_Program_Audio_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Program_Audio_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Audio du programme (optionnel)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Programm-Audio (optional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Audio del programma (facoltativo)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиопрограмма (необязательно)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Audio del programa (opcional)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("节目音频（可选）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムオーディオ（オプション）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम का ऑडियो (वैकल्पिक)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Áudio do programa (opcional)")
	return /** @type {LocalizedString} */ ("Program Audio (Optional)")
});